module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverDashboard",
      "subNavTitle": 'Statistics',
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-card', [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3",
      "fill": "",
      "align": "center",
      "active-nav-item-class": "font-weight-bold"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Statistics by status",
      "active": ""
    }
  }, [_c('b-card-text', {
    staticClass: "borderRounded"
  }, [_c('graph-panel', {
    attrs: {
      "graphTitle": "Amount of the transactions",
      "periodes": ['day', 'week', 'month', 'year'],
      "ibans": _vm.ibans,
      "contacts": _vm.contacts,
      "trueValueLabel": "Show Amount",
      "falseValueLabel": "Show Number"
    },
    on: {
      "fetch-periode": function($event) {
        return _vm.fetchGraphStatus($event)
      },
      "filter-graph": function($event) {
        return _vm.filterStatus($event)
      },
      "clear-filter": function($event) {
        return _vm.clearFilterStatus()
      }
    },
    model: {
      value: (_vm.showingStatus),
      callback: function($$v) {
        _vm.showingStatus = $$v
      },
      expression: "showingStatus"
    }
  }, [_c('graph-by-status', {
    attrs: {
      "showAmountNotNumber": _vm.showingStatus
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Statistics by balance"
    }
  }, [_c('b-card-text', {
    staticClass: "borderRounded"
  }, [_c('graph-panel', {
    attrs: {
      "graphTitle": "Sent and Received Transactions",
      "periodes": ['day', 'week', 'month', 'year'],
      "ibans": _vm.ibans,
      "contacts": _vm.contacts,
      "trueValueLabel": "Show Transactions",
      "falseValueLabel": "Show Treasury"
    },
    on: {
      "fetch-periode": function($event) {
        return _vm.fetchGraphBalance($event)
      },
      "filter-graph": function($event) {
        return _vm.filterBalance($event)
      },
      "clear-filter": function($event) {
        return _vm.clearFilterBalance()
      }
    },
    model: {
      value: (_vm.showingBalance),
      callback: function($$v) {
        _vm.showingBalance = $$v
      },
      expression: "showingBalance"
    }
  }, [_c('graph-by-balance', {
    attrs: {
      "showTransactionsNotTreasury": _vm.showingBalance
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Statistics by creditors"
    }
  }, [_c('b-card-text', {
    staticClass: "borderRounded"
  }, [_c('graph-panel', {
    attrs: {
      "graphTitle": "Creditors (sent transactions)",
      "periodes": ['day', 'week', 'month', 'year'],
      "ibans": _vm.ibans,
      "contacts": _vm.contacts,
      "trueValueLabel": "Show Amount",
      "falseValueLabel": "Show Number"
    },
    on: {
      "fetch-periode": function($event) {
        return _vm.fetchGraphContact($event)
      },
      "filter-graph": function($event) {
        return _vm.filterContact($event)
      },
      "clear-filter": function($event) {
        return _vm.clearFilterContact()
      }
    },
    model: {
      value: (_vm.showingContact),
      callback: function($$v) {
        _vm.showingContact = $$v
      },
      expression: "showingContact"
    }
  }, [_c('graph-by-contact', {
    attrs: {
      "showSentNotReceived": true,
      "showAmountNotNumber": _vm.showingContact
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Statistics by debtors"
    }
  }, [_c('b-card-text', {
    staticClass: "borderRounded"
  }, [_c('graph-panel', {
    attrs: {
      "graphTitle": "Debtors (received transactions)",
      "periodes": ['day', 'week', 'month', 'year'],
      "ibans": _vm.ibans,
      "contacts": _vm.contacts,
      "trueValueLabel": "Show Amount",
      "falseValueLabel": "Show Number"
    },
    on: {
      "fetch-periode": function($event) {
        return _vm.fetchGraphContact($event)
      },
      "filter-graph": function($event) {
        return _vm.filterContact($event)
      },
      "clear-filter": function($event) {
        return _vm.clearFilterContact()
      }
    },
    model: {
      value: (_vm.showingContact),
      callback: function($$v) {
        _vm.showingContact = $$v
      },
      expression: "showingContact"
    }
  }, [_c('graph-by-contact', {
    attrs: {
      "showSentNotReceived": false,
      "showAmountNotNumber": _vm.showingContact
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75267f4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75267f4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/StatisticsPage.vue
// module id = 1695
// module chunks = 2